import * as React from "react";
function SvgHeart(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M14.61 28.44a2 2 0 002.78 0c3.17-3 10.81-10.54 12.58-14C32.4 9.57 30.45 3.59 25 3h-.83A8.42 8.42 0 0016 9.24 8.42 8.42 0 007.81 3H7c-5.45.59-7.4 6.57-5 11.39 1.81 3.51 9.44 11.02 12.61 14.05z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgHeart);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
